// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"db10de6f","201":"3aef7740","688":"58bbf953","952":"455ac51c","982":"055fc64f"}[chunkId] + ".chunk.css";
};